import { useDispatch, useSelector } from 'react-redux';
import { RefObject, useEffect } from 'react';
import { selectWidgetIdToFocus } from '@mm/state/selectors/viewSelectors';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import viewActions from '@mm/state/actions/viewActions';

export const useWidgetCreateScrollEffect = (
  entityId: number,
  ref?: RefObject<HTMLDivElement | null>,
) => {
  const widgetIdToFocus = useSelector(selectWidgetIdToFocus);

  const dispatch: Dispatch<StoreState> = useDispatch();

  const cleanState = () => {
    dispatch(viewActions.setWidgetToFocus(undefined));
  };

  useEffect(() => {
    const el = ref?.current;
    if (widgetIdToFocus === entityId && el) {
      cleanState();
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [widgetIdToFocus]);
};
